import { GlobalMessageAction, GlobalMessageActions } from "../actions/global-message-actions";

const INITIAL_STATE: Object = {
    isVisible: false,
    isSuccess: false,
    response: "",
};

export function globalMessageReducer(state: Object = INITIAL_STATE, action: GlobalMessageAction) {
    switch (action.type) {
        case GlobalMessageActions.SHOW_MESSAGE:
            return {...state, isVisible: true, isSuccess: action.status === "SUCCESS", response: action.response};
        case GlobalMessageActions.HIDE_MESSAGE:
            return {...state, isVisible: false, isSuccess: false, response: ""};
        default:
            return state;
    }
}
